"use client";

import React from "react";
import { IoIosSearch } from "react-icons/io";

interface HeroSectionProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  handleSearch: () => void;
}

const HeroSection: React.FC<HeroSectionProps> = ({
  searchQuery,
  setSearchQuery,
  handleSearch,
}) => {
  return (
    <section className="bg-[#4887f5]">
      <div className="rounded-b-semifull bg-[#E9E9EA] pb-8 sm:pb-10 md:pb-14 lg:pb-16">
        <div className="rounded-b-semifull relative bg-[#27335d] py-10 text-white md:py-16">
          {/* Hero Section */}
          <div className="mx-auto flex flex-row items-center justify-center md:mt-10">
            <div className="text-center">
              <p className="text-xl font-bold xsm:text-xl sm:text-2xl md:text-5xl lg:text-6xl xl:text-7xl">
                Help
              </p>
            </div>
          </div>
          <div className="justify- flex flex-col items-center xsm:my-6 sm:my-7 md:my-8 lg:my-9 xl:my-10">
            <p className="text-center text-xs font-semibold text-white xsm:text-sm sm:text-lg md:text-xl lg:text-2xl xl:text-3xl">
              Help Is Just a Click Away!
            </p>
          </div>

          {/* Search */}
          <div className="flex flex-col items-center justify-center px-3 md:flex-row md:gap-2">
            {/* Search Bar */}
            <div>
              <div className="relative">
                <div className="absolute inset-y-0 left-4 flex items-center">
                  <IoIosSearch className="text-xl text-[#27335D]" />
                </div>
                <input
                  type="text"
                  placeholder="Search for help..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  data-testid="helpSearchInput"
                  className="flex items-center rounded-3xl border-2 border-[#4887F5] bg-white px-12 py-4 text-start font-semibold text-[#27335D] placeholder:text-xl focus:outline-none md:focus:border-[#1849A9] md:focus:outline-[#4887F5]"
                />
              </div>
            </div>

            {/* Search Button */}
            <button
              onClick={handleSearch}
              disabled={!searchQuery.trim()}
              data-testid="helpSearchButton"
              className={`rounded-b-5xl border-b-4 px-7 pb-2.5 pt-1 text-2xl font-bold transition duration-150 ease-in-out md:rounded-full md:py-3 ${
                !searchQuery.trim()
                  ? "cursor-not-allowed border-gray-400 bg-gray-300 text-gray-500"
                  : "cursor-pointer border-[#0c0f1c] bg-[#4887F5] text-[#27335D] hover:bg-[#6d9ff7] active:scale-95"
              }`}
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
